<template>
  <div class="fixed w-full early z-index99 top-0 closing">
    <!-- <b-modal id="isShowapp" class="cust-app-modal" hide-footer hide-header>
      <Popup />
    </b-modal> -->
    <div
      class="top5 fixed z-10 h-max items-center bg-primary p-1 rounded-lg lg:w-2/12"
    >
      <div>
        <div
          class="relative flex items-center bg-white rounded-md border border-gray-300 p-1 w-full"
        >
          <span class="text-black font-semibold pl-2">₹</span>

          <b-input
            class="flex-grow w-24 border-0 focus:ring-0 font-semibold"
            placeholder="Enter amount"
            name="amount"
            size="sm"
            v-model="amount"
          ></b-input>

          <base-button
            type="secondary"
            class="w-24 p-1 ml-2 bg-lightblue border-0"
            @click="DonatePage(amount)"
          >
            Donate Now
          </base-button>
        </div>
      </div>
      <!-- <span v-if="Err" class="small text-danger">{{ msg.err }}</span> -->
      <div v-if="Err" class="text-red-400 text-sm justify-self-center mt-1">
        {{ msg.err }}
      </div>
    </div>
    <b-modal
      id="isShowapp"
      class="cust-app-modal popupwidth"
      hide-footer
      hide-header
    >
      <Popup2 />
    </b-modal>
    <b-navbar
      toggleable="lg"
      class="relative flex flex-wrap w-full items-center justify-between py-4 lg:px-10 md:px-6 px-0 cust-trsprnt navbar"
      id="navbar"
    >
      <!-- <b-navbar-brand href="#">NavBar</b-navbar-brand> -->
      <div class="flex justify-between w-full items-center">
        <div class="flex items-center">
          <!-- <b-navbar-toggle
            target="nav-collapse"
            class=""
            ref="navbarRef"
          ></b-navbar-toggle> -->
          <a href="/" @click.prevent="redirectToHome">
            <div @contextmenu.prevent @click="handleClick('home')">
              <img
                src="../../assets/images/CSLogo.png"
                alt=""
                class="lg:ml-0 md:ml-0 ml-4 md:px-2 lg:px-2 px-0 py-2 cursor-pointer z-10 md:h-12 lg:h-12 h-12"
                style="pointer-events: none"
              />
            </div>
          </a>
        </div>
        <div class="">
          <b-collapse
            ref="closeOption"
            id="nav-collapse"
            is-nav
            class="lg:mt-0 md:mt-0 mt-20 lg:block md:block hidden"
          >
            <div
              @click="handleClose"
              class="lg:hidden md:hidden flex justify-end"
              target="nav-collapse"
            >
              <feather-icon icon="XIcon" />
            </div>
            <div class="lg:flex md:flex text-black items-center">
              <!-- <b-dropdown
                id="dropdown-offset"
                text="Caregiver"
                class="cust-bg-btn cust-p-0"
              >
                <b-dropdown-item
                  @click="handleClick('caregiver')"
                  class="font-semibold text-lg hovercolor dropdowntext"
                  >Caregiver</b-dropdown-item
                >
                <b-dropdown-item
                  @click="handleClick('about-us')"
                  class="font-semibold text-lg hovercolor dropdowntext"
                  >About Us</b-dropdown-item
                >
              </b-dropdown> -->

              <slot name="menu"></slot>

              <!-- <div class="px-6 cursor-pointer" @click="handleClick('join-us')">
                <p class="font-semibold text-lg hovercolor">
                  Join Us
                </p>
              </div> -->
            </div>
            <!-- <b-navbar-nav class="ml-auto">
           <b-nav-item-dropdown text="Lang" right>
            <b-dropdown-item href="#">EN</b-dropdown-item>
            <b-dropdown-item href="#">ES</b-dropdown-item>
            <b-dropdown-item href="#">RU</b-dropdown-item>
            <b-dropdown-item href="#">FA</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav> -->
          </b-collapse>
        </div>
        <div class="flex items-center text-primary lg:pr-0 md:pr-0">
          <!-- <div
            class="md:px-3 lg:px-3 px-3 md:block lg:block hidden cursor-pointer"
          <div
            class="md:px-3 lg:px-3 px-3 block cursor-pointer"
            @click="handleappLink"
            v-b-modal.modal-1
          > -->
          <!-- <div
            class="md:px-3 lg:px-3 px-1 block cursor-pointer lg:block md:block hidden"
            v-b-modal.translate-modal
          >
            <img
              src="../../assets/images/translation.png"
              class="mx-auto h-6 w-6"
              alt="img"
            />
            <small class="mt-1 font-semibold lg:block md:block hidden"
              >Translate
            </small>
          </div> -->
          <div
            class="md:px-3 lg:px-3 px-1 cursor-pointer lg:block md:block block"
            @click="handleClick('subscribe1')"
          >
            <img
              src="https://nexuscluster.blob.core.windows.net/server01/caregiversaathi/image/plans.png"
              class="mx-auto h-6 w-6"
              alt="img"
            />
            <small class="mt-1 font-semibold lg:block md:block hidden"
              >Plans
            </small>
          </div>
          <div
            class="md:px-3 lg:px-3 px-1 block cursor-pointer lg:block md:block hidden"
            @click="handleClick('product-services')"
          >
            <img
              src="../../assets/images/shopping-cart.png"
              class="mx-auto h-6 w-6"
              alt="img"
            />
            <small class="mt-1 font-semibold lg:block md:block hidden"
              >Shop
            </small>
          </div>

          <!-- <div
            class="md:px-3 lg:px-3 px-1 block cursor-pointer lg:block md:block hidden"
            v-b-modal.isShowapp
          >
            <img
              src="../../assets/images/smartphone.png"
              class="mx-auto h-6 w-6"
              alt=""
            />
            <small class="mt-1 font-semibold lg:block md:block hidden"
              >Get App</small
            >
          </div> -->
          <div
            class="md:px-4 lg:px-3 px-1 cursor-pointer lg:block md:block hidden"
            @click="handleClick('donation')"
          >
            <!-- <a
              target="_blank"
              href="https://pages.razorpay.com/caregiversaathi-donation"
            >
            </a> -->
            <img
              src="../../assets/images/heart.png"
              class="mx-auto h-6 w-6"
              alt=""
            />
            <small class="mt-1 font-semibold md:block lg:block hidden"
              >Donate
            </small>
          </div>
          <!-- <feather-icon
            icon="MenuIcon"
            v-b-toggle.sidebar-right
            class="lg:hidden md:hidden block"
          /> -->
          <div class="md:px-4 lg:px-3 px-1 cursor-pointer block">
            <b-navbar-toggle
              target="nav-collapse1"
              class="lg:hidden md:hidden block"
              ref="navbarRef"
              v-b-toggle.sidebar-right
            ></b-navbar-toggle>
            <b-dropdown
              id="dropdown-1"
              size="lg"
              variant="link"
              toggle-class="text-decoration-none dropdownicon py-0 px-0 items-baseline"
              class="m-md-2 rounded-md cust-droppad dottedropdown bg-transparent cust-bg-btn cust-p-0 lg:block md:block hidden"
              no-caret
              right
            >
              <template #button-content>
                <div class="cursor-pointer">
                  <div>
                    <img
                      src="../../assets/images/user.png"
                      class="mx-auto lg:block md:block hidden h-6 w-6"
                      alt=""
                    />
                  </div>
                  <small
                    class="mt-1 text-primary font-semibold md:block lg:block hidden"
                    >Profile</small
                  >
                </div>
              </template>
              <b-dropdown-item
                @click="handleLogin('signin', false)"
                v-if="!isLoggedIn"
                >Support Group</b-dropdown-item
              >
              <!-- <b-dropdown-item @click="handleClick('signin')" v-if="!isLoggedIn"
                >E-Learning</b-dropdown-item
              > -->
              <b-dropdown-item
                @click="handleLogin('signin', false)"
                v-if="!isLoggedIn"
                >Care Support Service</b-dropdown-item
              >
              <!-- <b-dropdown-item v-b-modal.translate-modal v-if="!isLoggedIn"
                >Translate</b-dropdown-item
              > -->
              <b-dropdown-item v-b-modal.isShowapp v-if="!isLoggedIn"
                >Get App</b-dropdown-item
              >

              <b-dropdown-item
                @click="handleLogin('signin', true)"
                v-if="!isLoggedIn"
                >Login</b-dropdown-item
              >

              <b-dropdown-item v-if="isLoggedIn" @click="handleClick('profile')"
                >Hi, {{ user.firstname }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="handleClick('social-channel')"
                v-if="isLoggedIn && !isLeader"
                >Support Group</b-dropdown-item
              >
              <!-- <b-dropdown-item
                @click="handleClick('e-home')"
                v-if="isLoggedIn && !isLeader"
                >E-Learning</b-dropdown-item
              > -->
              <!-- <b-dropdown-item
                @click="handleClick('services')"
                v-if="isLoggedIn && (isEmployee || isAdmin) && !isVolunteer"
                >Services</b-dropdown-item
              > -->
              <b-dropdown-item
                @click="handleClick('view-cart')"
                v-if="isLoggedIn && !isLeader"
                >Cart</b-dropdown-item
              >
              <b-dropdown-item
                @click="handleClick('care-assistance')"
                v-if="
                  isLoggedIn &&
                  (isEmployee || isAdmin || isStudent) &&
                  !isVolunteer &&
                  !isLeader
                "
                >Care Support Service</b-dropdown-item
              >
              <b-dropdown-item
                @click="handleClick('booking-page')"
                v-if="
                  isLoggedIn &&
                  (isEmployee || isAdmin || isStudent) &&
                  !isVolunteer &&
                  !isLeader
                "
                >My Booking</b-dropdown-item
              >
              <!-- <b-dropdown-item
                v-b-modal.translate-modal
                v-if="
                  isLoggedIn &&
                  (isEmployee || isAdmin || isStudent) &&
                  !isVolunteer &&
                  !isLeader
                "
                >Translate</b-dropdown-item
              > -->
              <b-dropdown-item
                v-b-modal.isShowapp
                v-if="
                  isLoggedIn &&
                  (isEmployee || isAdmin || isStudent) &&
                  !isVolunteer &&
                  !isLeader
                "
                >Get App</b-dropdown-item
              >
              <b-dropdown-item
                @click="handleClick('admin-user')"
                v-if="
                  isLoggedIn &&
                  isAdmin &&
                  user.role != 'intern' &&
                  user.role != 'leader'
                "
                >Admin</b-dropdown-item
              >
              <b-dropdown-item
                @click="handleClick('admin-dashboard')"
                v-if="
                  isLoggedIn &&
                  isAdmin &&
                  user.role != 'intern' &&
                  user.role == 'leader'
                "
                >Admin</b-dropdown-item
              >
              <b-dropdown-item
                @click="handleClick('blogs')"
                v-if="isLoggedIn && isAdmin && user.role == 'intern'"
                >Admin</b-dropdown-item
              >
              <b-dropdown-item
                @click="handleClick('volunteer')"
                v-if="isLoggedIn && isVolunteer && !isEmployee && !isAdmin"
                >Admin</b-dropdown-item
              >
              <b-dropdown-item
                @click="handleClick('vendor')"
                v-if="
                  isLoggedIn && user.role == 'vendor' && !isEmployee && !isAdmin
                "
                >Admin</b-dropdown-item
              >
              <b-dropdown-item @click="Logout()" v-if="isLoggedIn">
                <div class="flex items-center py-2">
                  <feather-icon icon="LogInIcon" svgClasses="w-4 h-4 mr-2 " />
                  <p class="text-sm font-medium" v-if="isLoggedIn">Logout</p>
                </div></b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
    </b-navbar>

    <b-sidebar
      id="sidebar-right"
      right
      bg-variant="white"
      shadow
      class="lg:hidden md:hidden block"
    >
      <header>
        <img
          src="../../assets/images/CSLogo.png"
          alt=""
          class="pt-3 pl-4 h-12"
          @click="handleClick('home')"
        />
      </header>
      <div class="h-100vh px-2 py-4">
        <div class="lg:flex md:flex text-black items-center">
          <slot name="menu"></slot>
        </div>

        <div class="px-5" v-if="!isLoggedIn">
          <div class="btnn text-center" @click="handleLogin('signin', true)">
            Login
          </div>
          <div class="btnn text-center mt-2" @click="handleClick('register')">
            Register
          </div>
        </div>
        <div class="" v-if="isLoggedIn">
          <b-dropdown
            :text="'Hi ' + user.firstname"
            id="dropdown-1"
            size="lg"
            variant="link"
            toggle-class="text-decoration-none py-1 px-1"
            class="m-md-2 rounded-md cust-droppad dottedropdown bg-transparent cust-bg-btn cust-p-0"
            no-caret
            right
          >
            <template>
              <div class="cursor-pointer">
                <!-- <small class="font-semibold block fsize14">My Profile</small> -->
              </div>
            </template>

            <b-dropdown-item v-if="isLoggedIn" @click="handleClick('profile')"
              >My Profile
            </b-dropdown-item>
            <b-dropdown-item
              @click="handleClick('social-channel')"
              v-if="isLoggedIn && !isLeader"
              >Support Group</b-dropdown-item
            >
            <!-- <b-dropdown-item
              @click="handleClick('e-home')"
              v-if="isLoggedIn && !isLeader"
              >E-Learning</b-dropdown-item
            > -->
            <!-- <b-dropdown-item
              @click="handleClick('services')"
              v-if="isLoggedIn && (isEmployee || isAdmin) && !isVolunteer"
              >Services</b-dropdown-item
            > -->
            <b-dropdown-item
              @click="handleClick('view-cart')"
              v-if="isLoggedIn && !isLeader"
              >Cart</b-dropdown-item
            >
            <b-dropdown-item
              @click="handleClick('care-assistance')"
              v-if="
                isLoggedIn &&
                (isEmployee || isAdmin || isStudent) &&
                !isVolunteer &&
                !isLeader
              "
              >Care Support Service</b-dropdown-item
            >
            <b-dropdown-item
              @click="handleClick('booking-page')"
              v-if="
                isLoggedIn &&
                (isEmployee || isAdmin || isStudent) &&
                !isVolunteer &&
                !isLeader
              "
              >My Booking</b-dropdown-item
            >
            <b-dropdown-item
              @click="handleClick('admin-user')"
              v-if="
                isLoggedIn &&
                isAdmin &&
                user.role != 'intern' &&
                user.role != 'leader'
              "
              >Admin</b-dropdown-item
            >
            <b-dropdown-item
              @click="handleClick('admin-dashboard')"
              v-if="
                isLoggedIn &&
                isAdmin &&
                user.role != 'intern' &&
                user.role == 'leader'
              "
              >Admin</b-dropdown-item
            >
            <b-dropdown-item
              @click="handleClick('blogs')"
              v-if="isLoggedIn && isAdmin && user.role == 'intern'"
              >Admin</b-dropdown-item
            >

            <b-dropdown-item
              @click="handleClick('volunteer')"
              v-if="isLoggedIn && isVolunteer && !isEmployee && !isAdmin"
              >Admin</b-dropdown-item
            >
            <b-dropdown-item
              @click="handleClick('vendor')"
              v-if="
                isLoggedIn && user.role == 'vendor' && !isEmployee && !isAdmin
              "
              >Admin</b-dropdown-item
            >
            <!-- <b-dropdown-item @click="Logout()" v-if="isLoggedIn">
              <div class="flex items-center py-2">
                <feather-icon icon="LogInIcon" svgClasses="w-4 h-4 mr-2 " />
                <p class="text-sm font-medium" v-if="isLoggedIn">Logout</p>
                
              </div></b-dropdown-item
            > -->
          </b-dropdown>
        </div>
        <div class="flex justify-center gap-4 my-4">
          <div
            class="md:px-3 lg:px-3 px-1 block cursor-pointer"
            v-b-modal.translate-modal
          >
            <img
              src="../../assets/images/translation.png"
              class="mx-auto"
              alt="img"
            />
            <small class="mt-1 font-semibold block">Translate </small>
          </div>
          <div
            class="md:px-3 lg:px-3 px-1 cursor-pointer"
            @click="handleClick('product-services')"
          >
            <img
              src="../../assets/images/shopping-cart.png"
              class="mx-auto"
              alt="img"
            />
            <small class="mt-1 font-semibold fsize14">Shop </small>
          </div>
          <div class="md:px-3 lg:px-3 px-1 cursor-pointer" v-b-modal.isShowapp>
            <!-- v-b-modal.isShowthankspop -->
            <img
              src="../../assets/images/smartphone.png"
              class="mx-auto"
              alt=""
            />
            <small class="mt-1 font-semibold fsize14">Get App</small>
          </div>
          <div
            class="md:px-4 lg:px-4 px-1 cursor-pointer"
            @click="handleClick('donation')"
          >
            <img src="../../assets/images/heart.png" class="mx-auto" alt="" />
            <small class="mt-1 font-semibold fsize14">Donate </small>
          </div>
        </div>
        <div class="px-5">
          <div class="btnn text-center" @click="Logout()" v-if="isLoggedIn">
            Logout
          </div>
        </div>
      </div>
    </b-sidebar>
    <translate-modal></translate-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Popup2 from "./components/Popup2.vue";
import API from "@/apis";
import TemplatePreview from "../admin/pages/campaign-list/sms/campaignTemplate/TemplatePreview.vue";
import TranslateModal from "./components/TranslateModel.vue";

export default {
  components: { TemplatePreview, Popup2, TranslateModal },
  data() {
    return {
      navitems: [
        {
          text: "Caregiver2",
          route: "caregiver",
        },
        {
          text: "Well-wisher",
          route: "wellwisher",
        },
        {
          text: "Healthcare Professionals",
          route: "hcp",
        },
        {
          text: "Corporate",
          route: "corporate",
        },
      ],
      ishidenavbar: true,
      amount: 5000,
      Err: false,
      msg: {},
    };
  },
  watch: {
    $route() {
      this.scrollFunction();
    },

    amount(amount) {
      if (amount == "") {
        this.Err = false;
        return;
      }
      this.checkAmount(amount);
    },
  },

  methods: {
    logoutpopup() {
      this.$swal
        .fire({
          title: `Work in Progress`,
          text: "We are working to offer you the best experience",
          // buttonsStyling: false,
          showCancelButton: true,
          cancelButtonColor: "",
          confirmButtonClass: "btn btn-primary bg-primary",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          icon: "warning",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.Logout();
          }
        });
    },

    handleClick(name) {
      this.$router.push({ name: name });

      // this.toggleNavbar();
    },
    handleLogin(name, isLoginRoute) {
      this.$router.push({ name: name });
      if (!isLoginRoute) {
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
    async Logout() {
      try {
        await API.auth.logout();
        await this.$store.dispatch("auth/logout");
        await this.$store.commit("auth/logout");
        window.localStorage.clear();
        this.$swal.fire({
          title: `You've Successfully Logged Out `,
          text: "",
          // buttonsStyling: false,
          confirmButtonClass: "btn btn-primary bg-primary",
          confirmButtonText: "OK",
          icon: "success",
        });
      } catch (error) {
        if (error.response.data.code == 401) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "You've Logged Out",
            text: "",
            confirmButtonClass: "btn btn-primary bg-primary",
            confirmButtonText: "OK",
            icon: "success",
          });
        }
        await this.$store.commit("auth/logout");
      }
      this.handleClick("home");
      // window.location.reload();
    },
    redirectToHome(event) {
      event.preventDefault();
      this.$router.push({ name: "home" });
    },

    handleClose() {
      this.$refs.closeOption.toggle();
    },
    scrollFunction() {
      const isAdmin = ["admin"];
      const isProfile = ["profile"];
      const isChannel = ["channel"];
      const isRespite = ["care-assistance"];

      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20 ||
        this.$route.fullPath.includes(isAdmin) ||
        this.$route.fullPath.includes(isProfile) ||
        this.$route.fullPath.includes(isChannel) ||
        this.$route.fullPath.includes(isRespite)
      ) {
        document.getElementById("navbar").style.background = "#fff";
      } else {
        document.getElementById("navbar").style.background = "none";
      }
    },
    handleappLink() {
      //window.open(
      //  "https://play.google.com/store/apps/details?id=com.caregiversaathi"
      // );
      let el = document.getElementById("app-div");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    checkAmount(value) {
      if (!/^(0|[1-9]\d*)$/.test(value)) {
        this.Err = true;
        this.msg.err = "Enter a valid amount";
      } else {
        this.Err = false;
        this.msg.err = "";
      }
    },
    DonatePage(amount) {
      if (!/^(0|[1-9]\d*)$/.test(amount)) {
        this.Err = true;
        this.msg.err = "Enter a valid amount";
        return;
      }
      this.Err = false;
      this.amount = 5000;
      let donateURL = "https://pages.razorpay.com/caregiversaathi-donation";
      let donatePage = `${donateURL}?amount=${amount}`;
      window.open(donatePage);
    },
  },
  computed: {
    isLoggedIn() {
      return this.user && this.user._id != null;
      // return (
      //   localStorage.getItem("token") && this.user && this.user._id != null
      // );
    },
    isAdmin() {
      return (
        (this.user && this.user._id != null && this.user.role === "admin") ||
        (this.user && this.user._id != null && this.user.role === "author") ||
        (this.user && this.user._id != null && this.user.role === "leader") ||
        (this.user && this.user._id != null && this.user.role === "intern")
      );
    },

    isIntern() {
      this.user && this.user._id != null && this.user.role === "intern";
    },
    isEmployee() {
      return (
        this.user && this.user._id != null && this.user.role === "employee"
      );
    },
    isLeader() {
      return this.user && this.user._id != null && this.user.role === "leader";
    },
    isVolunteer() {
      return (
        this.user && this.user._id != null && this.user.role === "volunteer"
      );
    },
    isStudent() {
      return this.user && this.user._id != null && this.user.role === "student";
    },
    ...mapState("auth", ["user"]),
  },
  created() {
    window.addEventListener("scroll", this.scrollFunction);
  },
  mounted() {
    this.scrollFunction();
    // this.$store.commit("auth/user", {});
    this.$store.dispatch("campaignPageBanner/getMaster"); //for campaign page visible
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollFunction);
  },
};
</script>

<style scoped>
@media (min-width: 600px) {
  .cust-w130 {
    width: 270px;
  }
}
.z-index99 {
  z-index: 99;
}
.cust-w150 {
  width: 100px;
}

.hi-name > .vs-con-dropdown {
  color: #6d7176 !important;
  font-size: 15px !important;
  font-weight: 500;
}
.hiuser {
  font-weight: 500;
  font-size: 15px;
  /* font-family: "Montserrat", Helvetica, Arial, sans-serif !important; */
  line-height: 23px;
}
cust-trsprnt::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
cust-trsprnt::-webkit-scrollbar {
  width: 14px;
}

cust-trsprnt::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  background: #ffffff;
  opacity: 0.5;
}
.navlink-active {
  color: #00adc0;
}
.bg-Img .modal-content {
  background-color: red !important;
}
.bg-Img .modal-body {
  padding: 0px !important;
}

.b-sidebar-outer {
  margin-left: 20%;
  width: 80%;
  position: absolute;
  top: 0;
  z-index: 50;
}
.h-100vh {
  height: 100vh;
}
.dropdown-toggle::after {
  margin-top: 6px !important;
}
.top5 {
  top: 70px;
  right: 55px;
}
@media (max-width: 640px) {
  .top5 {
    right: 5px;
  }
}
</style>
